<template>
  <header class="header-global">
    <base-nav
      class="navbar-main"
      transparent
      type
      effect="light"
      expand
    >
      <!-- <router-link
        slot="brand"
        class="navbar-brand mr-lg-5"
        to="/"
      >
        <img
          src="https://user-images.githubusercontent.com/7906289/45718714-09330200-bb6c-11e8-8a60-5da580086a5f.png"
          alt="logo"
        />
      </router-link>-->

      <div
        class="row"
        slot="content-header"
        slot-scope="{closeMenu}"
      >
        <div class="col-6 collapse-brand">
          <img
            src="https://user-images.githubusercontent.com/7906289/45718714-09330200-bb6c-11e8-8a60-5da580086a5f.png"
            alt="logo"
          /> Isabl
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="https://isabl.gitbook.io/docs"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="See Isabl Platform documentation"
          >
            <font-awesome-icon icon="book" />
            <span class="nav-link-inner--text d-lg-none">Documentation</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="https://github.com/isabl-io"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="Star us on Github"
          >
            <font-awesome-icon :icon="['fab', 'github']" />
            <span class="nav-link-inner--text d-lg-none">Github</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="https://twitter.com/PapaemmanuilLab"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="Follow us on Twitter"
          >
            <font-awesome-icon :icon="['fab', 'twitter']" />
            <span class="nav-link-inner--text d-lg-none">Twitter</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="https://bmcbioinformatics.biomedcentral.com/articles/10.1186/s12859-020-03879-7"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="Know our lab"
          >
            <font-awesome-icon icon="dna" />
            <span class="nav-link-inner--text d-lg-none">MSK Lab</span>
          </a>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
};
</script>
<style>
</style>
